import React from 'react';

import Card from "../../../card";
import { GroupItem, NameValuePair } from '../models';
import OrderGroupItem from './order-group-item';
import OrderLineItem from './order-line-item';
import { OrderGroupContainer, OrderGroupContainerLastEntry } from './style';

type ProductSectionProps = {
    products: GroupItem[];
    className?: string;
    title: string;
    isEng?: boolean;
};

export default function ProductSection({
    products,
    className,
    title,
    isEng  // cannot have default value, null means French
}: ProductSectionProps) {
    const renderGroupItem = ({
        index,
        productDetailEntries
    }: {
        index: number;
        productDetailEntries: NameValuePair[];
    }) => {
        return <OrderGroupItem key={index} orderGroupItems={productDetailEntries} />;
    };

    const renderLineItem = ({
        key,
        itemDetailEntries,
        htmlElement
    }: {
        key?: number | string;
        itemDetailEntries: NameValuePair[];
        htmlElement: React.JSX.Element;
    }) => {
        const pageContent = <>
            <OrderLineItem key={key} lineItems={itemDetailEntries}/>
            {htmlElement && htmlElement}
        </>;
        return pageContent;
    };

    return (
        <Card
            className={className}
            title={title}
            content={
                <>
                    {products?.map(({ productDetailEntriesEn, productDetailEntriesFr, items }, index) => (
                        <>
                            {index + 1 < products.length && <OrderGroupContainer key={`${index}-group`}>
                                {renderGroupItem({ 
                                    index, 
                                    productDetailEntries: isEng ? productDetailEntriesEn : productDetailEntriesFr
                                })}
                                {items.map(({ itemDetailEntriesEn, itemDetailEntriesFr, htmlElement }) =>
                                    renderLineItem({
                                        key: index,
                                        itemDetailEntries: isEng ? itemDetailEntriesEn : itemDetailEntriesFr,
                                        htmlElement
                                    })
                                )}
                            </OrderGroupContainer>}
                            {index + 1 == products.length && <OrderGroupContainerLastEntry key={`${index}-group`}>
                                {renderGroupItem({ 
                                    index, 
                                    productDetailEntries: isEng ? productDetailEntriesEn : productDetailEntriesFr
                                })}
                                {items.map(({ itemDetailEntriesEn, itemDetailEntriesFr, htmlElement }) =>
                                    renderLineItem({
                                        key: index,
                                        itemDetailEntries: isEng ? itemDetailEntriesEn : itemDetailEntriesFr,
                                        htmlElement
                                    })
                                )}
                            </OrderGroupContainerLastEntry>}
                        </>
                    ))}
                </>
            }
        />
    );
}
